<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>

export default {
  
 data() {
    return {

 
  }
  },
  created(){
    if (localStorage.getItem("username") != null) {
     
      if(location.pathname == "/crm/") {
        this.$router.push("/callshow")
      
      }
    } else {
      if(location.pathname !== "/crm/") {
        this.$router.push("/");
      }
    }
  }
  
};


</script>



